/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Elements with a tabindex attr will get an outline
// when clicked. They should only get it when tabbed to.
//
// http://stackoverflow.com/a/21591278
$(document).ready(() => $(document).on('keyup', function(e) {
  if (e.keyCode === 9) { // tab key
    // remove outline from previously focused element
    $('.u-tabindex-focus').removeClass('u-tabindex-focus');

    // add outline to the focused element
    if (e.target.hasAttribute('tabindex')) {
      return $(e.target).addClass('u-tabindex-focus');
    }
  }
}));
